import { Article } from '@api/api';
import { articleApiClient } from '@api/clients';
import { useQuery, UseQueryResult } from 'react-query';

export const fetchArticles = async (params?): Promise<Article[]> => {
  const { data } = await articleApiClient.articlesGet({}, { params });
  return data;
};

export const useArticles = (params?, enabled = true): UseQueryResult<Article[]> => {
  return useQuery(['articles', params], () => fetchArticles(params), { enabled });
};
